import { PackageGroupDTO } from "./package-group-dto";
import { PackageGroupServiceDTO } from "./package-group-service-dto";

export class HandlePackageGroupsDoneSave {
  public PackageGroups: PackageGroupDTO[];
  public PackageGroupServices: PackageGroupServiceDTO[];
}
